import Footer from "../../footer"
import NavBar from "../../nav"

const Manuals = () => {
  return <div className='all-manuals'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Fly Compliant Manuals (FCMs)</h1>
				<div className="headline-divider sections"></div>
				<h2>Supporting operations of all sizes, under each operating rule.</h2>
			</div>
		</section>
    <section className="grid-links-container row">
			<div className="container my-5">
				<div className="row">
					<div className="col-12 col-md-4 d-flex">
						<a href="/manuals/training" className="grid-links grow text-center">
							<h3>Training</h3>
							<p>Modular Training Programs &amp; Curriculum <br /> Training that matches the guidance.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex my-3 my-md-0">
						<a href="/manuals/sops" className="grid-links grow text-center">
							<h3>SOPS</h3>
							<p>The core of our manual system. <br /> Our Collective Resource Management for SMS.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex">
						<a href="/manuals/rvsm-operations" className="grid-links grow text-center">
							<h3>RVSM Operations</h3>
							<p>Domestic and International Operations <br /> Keeping up-to-date with the FAA.</p>
						</a>
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-md-4 d-flex">
						<a href="/manuals/hazardous-materials" className="grid-links grow text-center">
							<h3>Hazardous Materials</h3>
							<p>Carriage and Non-Carriage <br /> Keeping Our Clients Compliant.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex my-3 my-md-0">
						<a href="/manuals/minimum-equipment-list" className="grid-links grow text-center">
							<h3>Minimum Equipment List</h3>
							<p>Developed to your specific aircraft configuration or fleet.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex">
						<a href="/manuals/international-procedures" className="grid-links grow text-center">
							<h3>International Procedures</h3>
							<p>Procedurally Oriented Manuals &amp; Standards</p>
						</a>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default Manuals